// TODO: detect if menu items are slotted and add class to ul

import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-form-select',
  styleUrl: 'form.css',
  shadow: false,
})
export class FormSelect {
  @Prop() selectName: string = 'selectName';
  @Prop() selectId: string = 'selectID';
  @Prop() selectSize: number = 1;

  render() {
    return (
      <div class="form_response">
        <select id={this.selectId} name={this.selectName} size={this.selectSize} autocomplete="off">
          <option></option>
          <slot />
        </select>
      </div>
    );
  }
}
